import SystemClassifiers from "../lang/system-classifiers";
import {FieldRequireType} from "./General";
import {mappedLanguagesById} from "../lang/i18n";
import {LanguagesType} from "./Languages";

export type TaskType = {
    TaskId: string,
    TaskGuid: string,
    TaskType: number,
    OrderNo: string,
    OrderReference: string,
    Sequence: number,

    TripId: number,
    AddressId: string,

    Sender: string,
    FirstLoadingAddress: string,
    LoadingReference: string,
    AdditionalStopTypeId?: number | undefined,

    Consignee: string,
    LastDeliveryAddress: string,
    DeliveryReference: string,

    CargoDescriptionHtml: string,

    PlannedArrivalDate: string,
    PlannedArrivalTime: string,
    PlannedArrivalDateFix: number,
    TaskCompletedDate: string, // This is the property that tells us if the task was done
    TaskCompletedButtonTranslationId: number,

    FileUploadFolderName: string,
    FileUploadSubFolderName: string,

    AddPhotoIsVisible: boolean,
    PhotoFileName: string,
    PhotoRequiredType: FieldRequireType,
    PhotoUploadedCount: number,

    AddCmrIsVisible: boolean,
    CmrFileName: string,
    CmrRequiredType: FieldRequireType,
    CmrUploadedCount: number,

    AddTempMeasurementIsVisible: boolean,
    TempMeasurementFileName: string,
    TempMeasurementRequiredType: FieldRequireType,
    TempMeasurementUploadedCount: number,

    AddPllExchangeCmrIsVisible: boolean,
    PllExchangeCmrRequiredType: FieldRequireType,
    PllExchangeCmrUploadedCount: number,
    PllExchangeCmrFileName: string,
    
    PllCountIsVisible: boolean,
    PllCountIsMandatory: boolean,
    PllCountTranslationId: number,
    PllCount: number,

    PllStackableIsVisible: boolean,
    PllStackableIsMandatory: boolean,
    PllStackableTranslationId: number,
    PllStackable: number,

    PllExchangeIsVisible: boolean,
    PllExchangeIsMandatory: boolean,
    PllExchangeTranslationId: number,
    PllExchange: number,
    
    BrutoIsVisible: boolean,
    BrutoIsMandatory: boolean,
    BrutoTranslationId: number,
    Bruto: number,

    LdmIsVisible: boolean,
    LdmIsMandatory: boolean,
    LdmTranslationId: number,
    Ldm: number,
    
    VolumeIsVisible: boolean,
    VolumeIsMandatory: boolean,
    VolumeTranslationId: number,
    Volume: number,
    
    TemperatureIsVisible: boolean,
    TemperatureIsMandatory: boolean,
    TemperatureTranslationId: number,
    TemperatureFrom: number,
    TemperatureTo: number,
    Temperature: number | null,

    NotesIsVisible: boolean,
    NotesIsMandatory: boolean,
    NotesTranslationId: number,
}

export enum TaskImageType {
    CMR = 'CMR',
    TEMP = 'TEMP',
    PLL = 'PLL',
    IMAGE = 'IMAGE',
}

export enum TaskImageTypeTranslationId {
    CMR = '2592',
    TEMP = '2602',
    PLL = '2594',
    IMAGE = '2593',
}

export const getTaskTypeName = (DefaultTaskTypeId: number, AdditionalStopTypeId: number, lang: LanguagesType) => {
    const classifierTypeId = DefaultTaskTypeId === 5 ? 306 : 359;
    const taskTypeId = DefaultTaskTypeId === 5 ? AdditionalStopTypeId : DefaultTaskTypeId;

    return SystemClassifiers.find((translation: any) => {
        return translation.Type === classifierTypeId && translation.LanguageId === mappedLanguagesById[lang] && translation.Id === taskTypeId;
    })?.Name ?? 'Unknown';
}

export const deconstructTaskId = (TaskId: string): number => {
    const array = TaskId.split('_');

    return parseInt(array[1]);
}
